import menu from './menu'
import loader from './loader'
import publico from './portal/publico'
import auth from './auth'
import seguranca from './portal/seguranca'
import dialog from './dialog'
import userInterface from './userInterface'
import cadastro from './cadastro'
import analise from './analise'
import vistoria from './vistoria'
import dashboard from './dashboard'
import certificacao from './certificacao'

const modules = {
  ...publico,
  ...cadastro,
  ...analise,
  ...seguranca,
  ...vistoria,
  ...dashboard,
  certificacao,
  loader,
  auth,
  dialog,
  menu,
  userInterface
}

export default modules



// WEBPACK FOOTER //
// ./src/store/modules/index.js